import { Injectable } from '@angular/core';
import { ModalService, ModalConfig } from './modal.service';
import { DeleteConfirmDialogComponent } from './delete-confirm-dialog/delete-confirm-dialog.component';
import { tap, take } from 'rxjs/operators';

@Injectable()
export class DeleteConfirmDialogService {
  constructor(
    private modalService: ModalService
  ) { }

  confirmDelete(message: string, oneLabel?: string, allLabel?: string, modalConfig: ModalConfig<any, DeleteConfirmDialogComponent> = {}) {
    return new Promise<'one' | 'all' | 'cancel'>((resolve) => {
      const ref = this.modalService.open(DeleteConfirmDialogComponent, {
        initialState: {
          type: 'dialog'
        },
        contentInitialState: {
          message,
          oneButtonLabel: oneLabel || 'Excluir Esta',
          allButtonLabel: allLabel || 'Excluir Todas'
        },
        ...modalConfig
      });

      ref.contentComponentRef.instance.confirm.pipe(take(1)).subscribe( (result: 'one' | 'all' | 'cancel') => {
        resolve(result);
      });
    });
  }
}
